let acc = document.getElementsByClassName("accordion");
let i;
$(document).ready(function() {
    // * Accordion for PublicConsultationView.cshtml
    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");

            let text = this.innerText.replace(/ .*/, "");
            if (this.classList.contains("active")) {
                this.innerText = text + " -";
            } else {
                this.innerText = text + " +";
            }

            /* Toggle between hiding and showing the active panel */
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }
});
